import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AppService } from '@app/services/app/app.service';
import { Session } from 'app/store/models/session.model';

import * as Objects from '@core/objects';
import { CurrentSessionService } from '@core/services/current-session/current-session.service';


@Injectable({
    providedIn: 'root'
})
export class AppCurrentSessionService implements CurrentSessionService {
    private session: Session = null;

    private user: Objects.User;
    private organization: Objects.Organization;
    
    constructor() {}
    
    set(session: Session) {
        if (null == session) return;
        this.user = session.current.user;
        this.organization = session.current.organization;
    }

    unset() {
        this.user = null;
        this.organization = null;
    }

    getUser = (): Objects.User | null => this.user;
    getOrganization = (): Objects.Organization | null => this.organization; 
}